<template>
  <KaffeemaschinenFinderApp/>
</template>

<script>
import KaffeemaschinenFinderApp from './components/KaffeemaschinenFinderApp.vue';


export default {
  name: 'App',
  components: {
    KaffeemaschinenFinderApp
  }
}
</script>

